import request from '@/utils/request'

export function getUsers(params) {
  return request({
    url: '/api/users',
    method: 'get',
    params
  })
}
 
export function getServices(params) {
  return request({
    url: '/api/v2/services',
    method: 'get',
    params
  })
}

export function getTables(params) {
  params = {...params, 'order[kilter]': 'asc'}

  return request({
    url: '/api/desks',
    method: 'get',
    params
  })
}

export function postOrder(data) {
  return request({
    url: '/api/orders',
    method: 'post',
    data
  })
}

export function putOrder(id, data) {
  return request({
    url: `/api/orders/${id}`,
    method: 'put',
    data
  })
}

export function getOrder(id){
  return request({
    url: `/api/orders/${id}`,
    method: 'get'
  })
}

export function getOrders(params) {
  return request({
    url: '/api/orders',
    method: 'get',
    params
  })
}

export function deleteOrder(id) {
  return request({
    url: `/api/orders/${id}`,
    method: 'delete'
  })
}

export function getShifts(params) {
  return request({
    url: `/api/v2/shifts`,
    method: 'get',
    params
  })
}

export function postShift(data) {
  return request({
    url: '/api/shifts',
    method: 'post',
    data
  })
}

export function getBills(params) {
  return request({
    url: `/api/bills`,
    method: 'get',
    params
  })
}

export function closeShift(id, data) {
  return request({
    url: `/api/shift/${id}/close`,
    method: 'put',
    data
  })
}

export function getCheck(id) {
  return request({
    url: `/api/orders/${id}/voucher`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/modules/booking/api.js